import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "projects-list" }
const _hoisted_2 = { class: "projects-list__filters-row projects-list__filters-row--header" }
const _hoisted_3 = { class: "jobs-panel-search__header-inputs" }
const _hoisted_4 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_5 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_6 = {
  key: 0,
  class: "projects-list__stages"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "tag-chip__count" }
const _hoisted_9 = { class: "projects-list__extra-filters" }
const _hoisted_10 = { class: "projects-list__counter" }
const _hoisted_11 = { class: "projects-list__counter-value" }
const _hoisted_12 = {
  key: 0,
  class: "projects-list__body-divider"
}

import {
	ref,
	computed,
	watch,
	onMounted,
	nextTick
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {searchStore} from "@/store/search";
import { clientPageStore } from "@/store/client-page";
import { headerStore } from "@/store/header";
import { ProjectApi } from "@/ api/ProjectApi";
import ProjectListItem from "@/components/main/search-panel/ProjectListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppSelect from "@/components/ui-kit/select/AppSelect.vue";
import ProjectClientFilterDropdown from "@/components/main/search-panel/dropdowns/ProjectClientFilterDropdown.vue";
import ProjectSelectedClientItem from "@/components/main/search-panel/ProjectSelectedClientItem.vue";
import SearchPanelToggleButton from "@/components/main/search-panel/SearchPanelToggleButton.vue";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { TagEntityType } from "@/models/etc/types";
import { i18n } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectSearchPanel',
  props: {
    isExpanded: { type: Boolean }
  },
  emits: ["on-toggle"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const t = (key: string): string => String(i18n.global.t(key))

const emit = __emit

const props = __props;

const $dropdownRef = ref<typeof AppResizableDropdown | null>(null)
const $clientFilterDropdownRef = ref<typeof AppResizableDropdown | null>(null)
const $filters = ref<HTMLDivElement | null>(null)
const $projectsList = ref<HTMLDivElement | null>(null)

// SearchPanel считает по ним минимальную высоту блока для ресайзера
__expose({
	filtersEl: $filters,
	bodyEl: $projectsList
})
const store = searchStore()
const clientPage = clientPageStore()
const header = headerStore()
const route = useRoute()
const router = useRouter()
const filter = ref("");
const selectedCategory = ref(-1);
const selectedTags = ref<TagWithFrequency[]>([])
const isCreatingProject = ref(false)
const initialLoadDone = ref(false)

const isEntityPage = computed(() => route.query.page === 'client' || route.query.page === 'project')
const entityType = computed<'client' | 'project'>(() => route.query.page === 'project' ? 'project' : 'client')
const entityId = computed(() => Number(route.query.id) || 0)

const byBaseItem = computed(() => ({ Id: -1, Name: t('search_by_base'), Roles: [] }))

const focusFilterClient = ref<{ Id: number, UseUnion: boolean } | null>(null)
const isClientFilterOpen = ref(false)

const openClientFilterAt = (client: { Id: number, UseUnion?: boolean }) => {
	focusFilterClient.value = { Id: client.Id, UseUnion: !!client.UseUnion }
	$clientFilterDropdownRef.value?.open()
}

const toggleClientFilter = () => {
	if (isClientFilterOpen.value) {
		$clientFilterDropdownRef.value?.close()
		return
	}
	focusFilterClient.value = null
	$clientFilterDropdownRef.value?.open()
}

const onClientFilterClose = () => {
	isClientFilterOpen.value = false
	focusFilterClient.value = null
}

const canCreateProject = computed(() => !!header.currentAccessGroup?.CanCreateProjects)
const createProjectTitle = computed(() =>
	t(canCreateProject.value ? 'project_create' : 'project_create_unavailable')
)
const createProjectHoverColor = computed(() =>
	canCreateProject.value ? '#499259' : '#979797'
)
const createProjectCursor = computed(() =>
	isCreatingProject.value ? 'wait' : (canCreateProject.value ? 'pointer' : 'not-allowed')
)

// Проматывает список проектов до открытого Проекта. Вызывается ТОЛЬКО при
// навигационной (первичной) загрузке — не при ручных поисках на той же странице.
const maybeScrollToOpenedProject = async () => {
	if (entityType.value !== 'project' || !entityId.value) {
		return
	}
	await nextTick()
	const container = $projectsList.value
	if (!container) {
		return
	}
	const el = container.querySelector(`[data-project-id="${entityId.value}"]`)
	if (!el) {
		return
	}
	const cRect = container.getBoundingClientRect()
	const eRect = el.getBoundingClientRect()
	container.scrollTop += eRect.top - cRect.top
}

onMounted(async () => {
	await store.getInitProjects()

	if (isEntityPage.value) {
		await store.loadClientFilterList(entityType.value, entityId.value)
		if (entityType.value === 'client') {
			const opened = clientPage.openedClient
			if (opened?.Id === entityId.value) {
				store.preselectClient({ Id: opened.Id, Name: opened.Name })
			}
		} else {
			store.preselectMainProjectClient()
		}
		await store.getFilteredProjects(filter.value)
		if (entityType.value === 'project') {
			await maybeScrollToOpenedProject()
		}
	}

	initialLoadDone.value = true

	// добор преселекта, если openedClient появился во время монтирования
	await tryPreselectOpenedClient()
})

const onProjectsScroll = () => {
	const el = $projectsList.value
	if (!el || projectsLoading.value) {
		return
	}
	if (el.scrollTop + el.clientHeight >= el.scrollHeight - 800) {
		store.getFilteredProjectsPartion(filter.value)
	}
}

const projects = computed(() => store.allProjects)
const projectsLoading = computed(() => store.projectsLoading || isCreatingProject.value)

const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$projectsList,
	'[data-project-id]',
	() => projects.value
)

const projectsCount = computed(() => store.projectCounter)
const projectsStagesList = computed(() => store.projectsStagesList)
const stageItemsForSelectedStage = computed(() => store.stageItemsForSelectedStage)
const allSelectedStages = computed(() => store.allSelectedStages)
const selectedClients = computed(() => store.selectedClients)
const byBase = computed(() => store.byBase)
// Фильтр по клиентам считается изменённым, пока он не равен «По базе»
const hasClientFilter = computed(() => isEntityPage.value && !byBase.value)

const hasAnyFilter = computed(() =>
	!!filter.value
	|| allSelectedStages.value.length > 0
	|| selectedTags.value.length > 0
	|| selectedCategory.value !== -1
	|| hasClientFilter.value
)

const optionsDisplay = computed(() => {
	if (!projectsStagesList.value.length) {
		return [{
			id: -1,
			label: t('stage_standard'),
			type: 'item'
		}]
	}

	return  projectsStagesList.value.map(stage => ({
		id: stage.Id,
		label: stage.Name,
		type: 'item'
	}))
})

const doSearch = async () => {
	$projectsList.value ? $projectsList.value.scrollTop = 0 : null
	await store.getFilteredProjects(filter.value);
}

function clearSearch() {
	filter.value = "";
}

async function toggleStage(stageId: number) {
	$projectsList.value ? $projectsList.value.scrollTop = 0 : null
	await store.setSelectedStage(stageId, filter.value)
}

const dropFilters = () => {
	filter.value = ""
	selectedCategory.value = -1
	selectedTags.value = []
	store.dropTags()
	if (isEntityPage.value) {
		store.setByBase(true)
	} else {
		store.clearClientFilter()
	}
	doSearch()
}

const dropTag = (tag: TagWithFrequency) => {
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
}

const removeClient = (id: number) => {
	store.removeSelectedClient(id)
	doSearch()
}

// Преселект открытого клиента (страница Клиента). Делает поиск только если действительно выбрал.
const tryPreselectOpenedClient = async () => {
	if (route.query.page !== 'client' || store.byBase) {
		return
	}
	const opened = clientPage.openedClient
	if (!opened?.Id || opened.Id !== entityId.value) {
		return
	}
	if (store.selectedClients.some(c => c.Id === opened.Id)) {
		return
	}
	store.preselectClient({ Id: opened.Id, Name: opened.Name })
	await doSearch()
}

const onCreateProject = async () => {
	if (isCreatingProject.value) {
		return
	}
	if (!canCreateProject.value || header.currentAccessGroupId == null) {
		return
	}

	try {
		isCreatingProject.value = true
		const clientId = store.selectedClients[0]?.Id ?? 0
		const newId = await ProjectApi.createProject(clientId, header.currentAccessGroupId)
		if (newId) {
			store.clearClientFilter()
			store.requestNameEdit({ type: 'project', id: newId })
			await router.push({
				path: '/main',
				query: {
					page: 'project',
					id: String(newId),
				}
			})
		}
	} catch (e) {
		console.error(e)
	} finally {
		isCreatingProject.value = false
	}
}

// Загрузка списка фильтра при открытии Клиента/Проекта/Главной
watch(
	() => [route.query.page, route.query.id],
	async (_curr, [prevPage]) => {
		if (!initialLoadDone.value) return
		if (isEntityPage.value) {
			await store.loadClientFilterList(entityType.value, entityId.value)
			if (entityType.value === 'project') {
				store.preselectMainProjectClient()
				await doSearch()
				await maybeScrollToOpenedProject()
			} else {
				const opened = clientPage.openedClient
				if (opened?.Id === entityId.value) {
					store.preselectClient({ Id: opened.Id, Name: opened.Name })
					await doSearch()
				}
				// иначе преселект и поиск сделает Watcher B по готовности openedClient
			}
		} else if (prevPage === 'client' || prevPage === 'project') {
			store.clearClientFilter()
			await doSearch()
		}
	}
)

// Добивает преселект открытого клиента, если он загрузился позже списка
watch(
	() => clientPage.openedClient?.Id ?? null,
	async () => {
		if (!initialLoadDone.value || route.query.page !== 'client' || store.byBase) {
			return
		}
		const opened = clientPage.openedClient
		if (!opened?.Id || opened.Id !== entityId.value) {
			return
		}
		if (store.selectedClients.some(c => c.Id === opened.Id)) {
			return
		}
		store.preselectClient({ Id: opened.Id, Name: opened.Name })
		await doSearch()
	}
)

watch(selectedTags, (newTags) => {
	store.selectedTags = newTags.map(t => t.Id)
}, { deep: true })

const chipStyle = (t: any) => {
	const active = allSelectedStages.value.includes(t.Id);
	const base = {
		borderLeftColor: t.Color,
		backgroundColor: 'transparent'
	}
	if (active) {
		base.backgroundColor = hexToRgba(t.Color, 0.2);
	}

	return base;
}

const chipColoredStyle = (t: any) => {
	return {
		backgroundColor: t.Color
	}
}

function hexToRgba(hex: string, alpha: number) {
	const res = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!res) return hex;
	const r = parseInt(res[1], 16);
	const g = parseInt(res[2], 16);
	const b = parseInt(res[3], 16);
	return `rgba(${r},${g},${b},${alpha})`;
}

watch(filter, (newValue, oldValue) => {
	if (!newValue && oldValue) {
		doSearch()
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

watch(selectedCategory, () => {
	store.selectedStage = selectedCategory.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "$filters",
      ref: $filters,
      class: "projects-list__filters"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppTooltip, { text: createProjectTitle.value }, {
          activator: _withCtx(() => [
            _createVNode(AppIcon, {
              class: "projects-list__filters-btn",
              name: "plus",
              width: "20px",
              color: "#979797",
              "hover-color": createProjectHoverColor.value,
              cursor: createProjectCursor.value,
              onClick: onCreateProject
            }, null, 8, ["hover-color", "cursor"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AppInput, {
              modelValue: filter.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
              placeholder: _ctx.$t('search_by_projects'),
              "show-search-button": "",
              onPressEnter: doSearch,
              onSearch: doSearch
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(AppSelect, {
              modelValue: selectedCategory.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCategory).value = $event)),
              placeholder: _ctx.$t('select_category'),
              items: optionsDisplay.value,
              "min-dropdown-width": 272,
              searchable: ""
            }, null, 8, ["modelValue", "placeholder", "items"])
          ])
        ]),
        _createVNode(SearchPanelToggleButton, {
          direction: props.isExpanded ? 'down' : 'up',
          tooltip: _ctx.$t(props.isExpanded ? 'ui_shrink' : 'ui_expand'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('on-toggle')))
        }, null, 8, ["direction", "tooltip"]),
        (isEntityPage.value)
          ? (_openBlock(), _createBlock(AppResizableDropdown, {
              key: 0,
              ref_key: "$clientFilterDropdownRef",
              ref: $clientFilterDropdownRef,
              class: "projects-list__client-filter-anchor",
              position: "right",
              "close-by-click-outside": true,
              "ignore-click-outside": "[data-client-filter-chip]",
              "max-width": 640,
              "max-height": 436,
              "mobile-title": _ctx.$t('choose_clients'),
              name: "$dropdownProjectClientFilter",
              onOpen: _cache[4] || (_cache[4] = ($event: any) => (isClientFilterOpen.value = true)),
              onClose: onClientFilterClose
            }, {
              default: _withCtx(() => [
                _createVNode(ProjectClientFilterDropdown, {
                  "focus-client": focusFilterClient.value,
                  onClose: _cache[3] || (_cache[3] = ($event: any) => ($clientFilterDropdownRef.value?.close())),
                  onChange: doSearch
                }, null, 8, ["focus-client"])
              ]),
              _: 1
            }, 8, ["mobile-title"]))
          : _createCommentVNode("", true)
      ]),
      (stageItemsForSelectedStage.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stageItemsForSelectedStage.value, (t) => {
              return (_openBlock(), _createBlock(AppTooltip, {
                key: t.Id,
                text: t.Name
              }, {
                activator: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "tag-chip",
                    style: _normalizeStyle(chipStyle(t)),
                    onClick: ($event: any) => (toggleStage(t.Id))
                  }, [
                    _createElementVNode("div", {
                      class: "tag-chip__colored",
                      style: _normalizeStyle(chipColoredStyle(t))
                    }, null, 4),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(t.Count), 1)
                  ], 12, _hoisted_7)
                ]),
                _: 2
              }, 1032, ["text"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(AppResizableDropdown, {
          ref_key: "$dropdownRef",
          ref: $dropdownRef,
          class: "projects-list__extra-filters-part",
          position: "right",
          "close-by-click-outside": true,
          "max-width": 640,
          "max-height": 436,
          "mobile-title": _ctx.$t('choose_tags'),
          name: "$dropdownRefClientsTags"
        }, {
          activator: _withCtx(() => [
            _createVNode(AppTooltip, {
              text: _ctx.$t('ui_tag_filter')
            }, {
              activator: _withCtx(() => [
                _createVNode(AppIcon, {
                  class: "projects-list__extra-filters-hash",
                  name: "hash",
                  size: "16px",
                  color: "#979797",
                  "hover-color": "#499259",
                  cursor: "pointer"
                })
              ]),
              _: 1
            }, 8, ["text"])
          ]),
          default: _withCtx(() => [
            _createVNode(AppTagSelector, {
              modelValue: selectedTags.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedTags).value = $event)),
              "entity-type": _unref(TagEntityType).Project,
              mode: "filter",
              "allow-create": "",
              "allow-select-group": "",
              onClose: _cache[6] || (_cache[6] = ($event: any) => ($dropdownRef.value?.close()))
            }, null, 8, ["modelValue", "entity-type"])
          ]),
          _: 1
        }, 8, ["mobile-title"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (tag) => {
          return (_openBlock(), _createElementBlock("span", {
            key: tag.Id,
            class: "projects-list__extra-filters-part projects-list__extra-filters-tag"
          }, [
            _createElementVNode("span", null, _toDisplayString(tag.Name), 1),
            _createVNode(AppIcon, {
              name: "close-bold",
              size: "12px",
              color: "#D2D2D2",
              "hover-color": "#4D4D4D",
              cursor: "pointer",
              onClick: _withModifiers(($event: any) => (dropTag(tag)), ["stop"])
            }, null, 8, ["onClick"])
          ]))
        }), 128)),
        (isEntityPage.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(AppTooltip, {
                class: "projects-list__extra-filters-part",
                text: _ctx.$t('clients_filter')
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    name: "filter",
                    size: "14px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer",
                    style: { marginTop: '-4px' },
                    "data-client-filter-chip": "",
                    onClick: _withModifiers(toggleClientFilter, ["stop"])
                  })
                ]),
                _: 1
              }, 8, ["text"]),
              (byBase.value)
                ? (_openBlock(), _createBlock(ProjectSelectedClientItem, {
                    key: 0,
                    client: byBaseItem.value,
                    "role-editable": false,
                    removable: false,
                    onOpenFilter: _cache[7] || (_cache[7] = ($event: any) => (openClientFilterAt(byBaseItem.value)))
                  }, null, 8, ["client"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedClients.value, (c, index) => {
                return (_openBlock(), _createBlock(ProjectSelectedClientItem, {
                  key: `${c.Id}-${c.UseUnion}`,
                  client: c,
                  separator: index + 1 < selectedClients.value.length,
                  onRemove: ($event: any) => (removeClient(c.Id)),
                  onChange: doSearch,
                  onOpenFilter: ($event: any) => (openClientFilterAt(c))
                }, null, 8, ["client", "separator", "onRemove", "onOpenFilter"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createElementVNode("div", {
      class: "projects-list__body",
      ref_key: "$projectsList",
      ref: $projectsList,
      onScroll: onProjectsScroll
    }, [
      (projectsLoading.value)
        ? (_openBlock(), _createBlock(AppLoader, {
            key: 0,
            style: _normalizeStyle(loaderStyle.value)
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.$t(hasAnyFilter.value ? 'projects_found' : 'projects_total')) + ":  ", 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(projectsCount.value), 1),
        (hasAnyFilter.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "projects-list__counter-drop-filters",
              onClick: _withModifiers(dropFilters, ["stop"])
            }, _toDisplayString(_ctx.$t('selector_reset')), 1))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: project.Id
        }, [
          _createVNode(ProjectListItem, { project: project }, null, 8, ["project"]),
          (index + 1 < projects.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createVNode(AppScrollTopButton, {
        enabled: _unref(isScrollTopEnabled),
        onOnClick: _unref(scrollToTop)
      }, null, 8, ["enabled", "onOnClick"])
    ], 544)
  ]))
}
}

})